import { useLocation, useNavigate } from "react-router-dom";
import SuccessScreen from "../../Common/SuccessScreen";

export const CompleteBuyerOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isInfluencer,
    isSupplierApprovalRequired,
    message,
    origin,
    billInfo,
    role,
  } = location.state || {};

  const approvalRequired = !!isSupplierApprovalRequired;
  // Buyer onboarded from the STP "sell to this buyer" flow → go straight to checkout.
  const isStpOrigin = origin === "inventory_stp" || origin === "dp_stp";
  const checkoutPath =
    origin === "dp_stp" ? "/dp/checkout" : "/inventory/checkout";

  const title = isInfluencer
    ? "Successfully Onboarded & e-KYC Verified!"
    : "Onboarded Successfully";

  const filledButtonAction = () => {
    if (isStpOrigin) {
      return navigate(checkoutPath, {
        state: {
          bill_info: billInfo,
          influencerTabSelected: true,
          selectedRole: role,
        },
      });
    }
    return navigate(approvalRequired ? "/my-network" : "/inventory");
  };
  const outlinedButtonAction = () => navigate("/");

  const filledButtonLabel =
    !isStpOrigin && approvalRequired ? "My Network" : "Sell Products";

  return (
    <SuccessScreen
      title={title}
      subtitle={message}
      filledButtonLabel={filledButtonLabel}
      filledButtonAction={filledButtonAction}
      OutlinedButtonLabel="Home"
      OutlinedButtonAction={outlinedButtonAction}
      buttonContainerWidth={{ xs: "100%", sm: "565px" }}
    />
  );
};

export default CompleteBuyerOnboarding;
